import React, { createRef, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import getRecaptchaConfig from '../../api/getRecaptchaConfig';

const ref = createRef();

const Recaptcha = ({ onChange }) => {
  const [siteKey, setSiteKey] = useState('');

  useEffect(() => {
    let isMounted = true;

    getRecaptchaConfig().then((loadedSiteKey) => {
      if (isMounted) {
        setSiteKey(loadedSiteKey || '');
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!siteKey) {
    return null;
  }

  return (
    <ReCAPTCHA
      sitekey={siteKey}
      onChange={onChange}
      ref={ref}
      size='invisible'
      badge='bottomleft'
    />
  );
};

export const executeRecaptcha = () => ref.current && ref.current.execute && ref.current.execute();
export const resetRecaptcha = () => ref.current && ref.current.reset && ref.current.reset();

export default Recaptcha;
